import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { useEffect } from "react";
import Spinner from "../../component/loadingbar/Spinner";

const AddClass = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();

  //--------------------------------- manage state ---------------------------------
  const [loading, setLoading] = useState(false);
  const [classnm, setClassnm] = useState("");

  const handleClassNmChange = (e) => {
    setClassnm(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setClassnm("");
    if (id) {
      navigate("/viewclass");
    }
  };

  //---------------------------------------------- get data for update / edit class ----------------------------------------------------r
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}classes/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setClassnm(data.data.class);
          setLoading(false);
        });
    }
  }, [id]);

  // ---------------------------------------------- create / add / update class -------------------------------------------------------c--u
  // Function to create a new class
  const addClassBtn = async () => {
    try {
      if (!classnm.trim()) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}classes/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            class: classnm,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // class created successfully
            triggerNotification(
              "success",
              `${
                id
                  ? "Class updated successfully."
                  : "Class created successfully."
              }`
            );
            setClassnm("");
            navigate("/viewclass");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating class:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the class."
      );
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Class" subpath={["Add Class"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Class</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* Class Name */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="cls"
                    id="cls"
                    placeholder="Class Name"
                    value={classnm}
                    onChange={handleClassNmChange}
                  />
                  <label htmlFor="cls"> Class Name</label>
                </div>
                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={addClassBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddClass;
